export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const RECEIVE_LOGIN = 'RECEIVE_LOGIN';
export const RECEIVE_LOGIN_ERROR = 'RECEIVE_LOGIN_ERROR';
export const RESET_LOGIN_ERROR = 'RESET_LOGIN_ERROR';
export const UNAUTHORIZED = 401;
export const INTERNAL_SERVER_ERROR = 500;
export const SHOW_FLASH_MESSAGE = 'SHOW_FLASH_MESSAGE';
export const HIDE_FLASH_MESSAGE = 'HIDE_FLASH_MESSAGE';
export const LOGOUT_SESSION = 'LOGOUT_SESSION';

export const INVALID_CREDENTIALS_ERROR = 'Invalid username and/or password.';
export const POSSIBLE_PASSWORD_EXPIRED_ERROR = [
  'We could not sign you in after multiple attempts. Your password may be incorrect or expired. Please update your password at https://mysignins.microsoft.com/security-info',
  'Note: Passwords expire every 3 months per IT department policy.'
].join('\n\n');
